export default function GridLayout({ children, className }) {
  return (
    <div
      className={`${className} grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8 w-full py-12`}
    >
      {children}
    </div>
  );
}
